import { Input, Text } from "@chakra-ui/react"
import { useFormik } from "formik";
import { useEffect, useState } from "react"
import { useSelector } from "react-redux"


export default function ProfileManager({ formik }) {

    const { user } = useSelector((state) => state.auth)

    const [userHasSetDisplayName, setUserHasSetDisplayName] = useState(undefined)

    useEffect(() => {
        if (!user)
            return

        if (user.preferences.publicProfile?.displayName !== undefined) {
            setUserHasSetDisplayName(true)
        } else {
            setUserHasSetDisplayName(false)
        }
    }, [user])

    if (!user || userHasSetDisplayName === undefined) {
        return (<></>)
    }

    return (
        <>
            {userHasSetDisplayName && (<>
                <Input
                    value={user.preferences.publicProfile.displayName}
                    isDisabled
                    size='sm'
                    readOnly
                />
                <Text fontSize="sm" mb={4}>Your public profile
                    {user.preferences.publicProfile?.enabled ? ' is ' : ' will be '}
                    visible at: {' '}
                    <Text
                        color="blue.500"
                        as="a"
                        href={`https://trainlookout.com/profile/${user.preferences.publicProfile.displayName}`}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        trainlookout.com/profile/{user.preferences.publicProfile.displayName}
                    </Text>
                </Text>
            </>)}
            {!userHasSetDisplayName && (<>
                <Text fontSize="sm" mb={4}>
                    Your display name is visible on your public profile. <br />
                    All display names are subject to approval and verification to prevent impersonation.
                </Text>
                <Input
                    name="displayName"
                    id="displayName"
                    value={formik.values.displayName}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    isInvalid={formik.errors.displayName && formik.touched.displayName}
                    placeholder="Display name"
                    autoFocus
                />
                <Text textDecoration="underline" fontSize="sm">
                    {`https://trainlookout.com/profile/${(
                        formik.errors.displayName === undefined &&
                        formik.values.displayName !== undefined &&
                        formik.values.displayName !== '')
                        ? formik.values.displayName : 'your-display-name'}`}
                </Text>
                {formik.errors.displayName && (
                    <Text color="red.500" fontSize="sm">{formik.errors.displayName}</Text>
                )}
            </>)}
        </>
    )
}